// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"060e7a75","150":"929f1231","235":"fb6373eb","264":"3c863434","320":"1ea1b188","329":"fb6373eb","393":"ff45c84d","507":"fb6373eb","632":"060e7a75","649":"fb6373eb","726":"fb6373eb","835":"060e7a75","957":"fb6373eb","971":"fb6373eb"}[chunkId] + ".chunk.css";
};